import React from 'react';
import { BlockStack, InlineGrid, Box, Card, Text, InlineStack, TextField, Button, Link, Layout } from '@shopify/polaris';

const LiveGoldRateAPI = ({ isAPIKeyVerified, isNewAPIKey, isAPIKeyVerifiedLoading, serviceApiKey, setServiceApiKey, handleConfigureAPIKey, apiKey }) => {
    return (
        <Layout.Section>
            <BlockStack gap={{ xs: "800", sm: "400" }}>
                <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
                    <Box
                        as="section"
                        paddingInlineStart={{ xs: 400, sm: 0 }}
                        paddingInlineEnd={{ xs: 400, sm: 0 }}
                    >
                        <BlockStack gap="400">
                            <Text as="h3" variant="headingMd">
                                Gold Price API Integration
                            </Text>
                            <Text as="p" variant="bodyMd">
                                Configure your API key to fetch live gold prices across various purities and currencies.
                            </Text>
                        </BlockStack>
                    </Box>
                    <Card roundedAbove="sm">
                        <BlockStack gap="400">
                            <Text variant="headingSm" as="h6">
                                {isAPIKeyVerified ? !isNewAPIKey ? 'Your API key is verified successfully ✅' : 'Follow these steps to get your API key:' : 'Follow these steps to get your API key:'}
                            </Text>
                            {isAPIKeyVerified && isNewAPIKey ? <BlockStack gap="200" paddingBlockEnd="200">
                                <Text as="p" tone="subdued">
                                    1. Go to <Link url="https://apised.com/apis/gold" external>APIsed Gold API</Link> and create an account.
                                </Text>
                                <Text as="p" tone="subdued">
                                    2. Purchase a suitable plan from the <Link url="https://apised.com/pricing" external>Pricing Page</Link>.
                                </Text>
                                <Text as="p" tone="subdued">
                                    3. Visit <Link url="https://apised.com/account/api-keys" external>your API key section</Link> and copy your key.
                                </Text>
                            </BlockStack> : null}
                            <InlineStack align='start' blockAlign='center' gap="200">
                                <TextField
                                    label="Enter Gold Service API Key"
                                    value={serviceApiKey}
                                    onChange={(value) => setServiceApiKey(value)}
                                    helpText={!isNewAPIKey ? 'Your api key is configured and we use that key to fetch gold prices.' : 'If you don\'t have an API key, we\'ll use our default key to fetch gold prices.'}
                                    autoComplete="off"
                                    maxLength={1000}
                                />
                                <Button
                                    loading={isAPIKeyVerifiedLoading}
                                    disabled={(apiKey === serviceApiKey && isAPIKeyVerified) || serviceApiKey.length === 0}
                                    variant="primary"
                                    onClick={handleConfigureAPIKey}
                                >
                                    {isAPIKeyVerified ? 'API Key Verified' : 'Verify API Key'}
                                </Button>
                            </InlineStack>
                        </BlockStack>
                    </Card>
                </InlineGrid>
            </BlockStack>
        </Layout.Section>
    );
};

export default LiveGoldRateAPI;
